import { useRouter } from 'next/router'
import React from 'react'
import Head from 'next/head'

import { HeaderBar, HeaderBarLeftAction } from '@wartek-id/header-bar'
import { historyUtils } from '@wartek-id/toolbox-helper'

import AssessmentSection from './components/AssessmentSection'
import FAQSection from './components/FAQSection'
import AboutAssessmentSection from './components/AboutAssessmentSection'
import JenjangSelectionSheet from './components/JenjangSelectionSheet'
import useSatuEventAssessment from './utils/useSatuEventAssessment'
import { EVENT_NAME_ASSESSMENT_VIEW_HOME_V1 } from './data'

const AssessmentApp = () => {
  const router = useRouter()
  const { SETrackEventAssessment } = useSatuEventAssessment()
  const [isJenjangSelectionSheetOpen, setIsJenjangSelectionSheetOpen] =
    React.useState(false)

  const onShowSheet = () => {
    setIsJenjangSelectionSheetOpen(true)
  }

  React.useEffect(() => {
    SETrackEventAssessment({
      eventName: EVENT_NAME_ASSESSMENT_VIEW_HOME_V1,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Head>
        <title>Asesmen</title>
        <meta name="description" content="Halaman utama asesmen" />
      </Head>
      <HeaderBar className="!shadow-none !sticky !top-0">
        <HeaderBarLeftAction
          onClick={() => historyUtils?.backToApp?.(router?.back)}
        />
      </HeaderBar>
      <div className="!bg-[#103178] min-h-[calc(100vh-54px)]">
        <AssessmentSection />
        <FAQSection />
        <AboutAssessmentSection onShowSheet={onShowSheet} />
      </div>
      <JenjangSelectionSheet
        isOpen={isJenjangSelectionSheetOpen}
        onClose={() => {
          setIsJenjangSelectionSheetOpen(false)
        }}
      />
    </>
  )
}

export default AssessmentApp
